import { type NavigateFunction, Params } from 'react-router-dom'

import i18n from 'modules/core/lib/i18n'
import { Navigation, NavigationPaths } from 'modules/core/lib/navigation/context'

type RouteParams = Readonly<Params<string>>

const onExportsModals =
  (params: RouteParams, navigate: NavigateFunction, navigation: Navigation<NavigationPaths>) =>
  () => {
    // Although the exclude process doesn't depend on a year and month, we
    // nest them in the same section to avoid an empty background.
    navigate(
      navigation.timeTracking.list.periodTypeYearMonthDay.exports.fullPath({
        periodType: params.periodType ?? '',
        year: Number(params.year),
        month: Number(params.month),
        day: Number(params.day),
      })
    )
  }

interface DownloadReportActionParams {
  params: RouteParams
  navigate: NavigateFunction
  navigation: Navigation<NavigationPaths>
}

export const downloadReportAction = ({
  params,
  navigate,
  navigation,
}: DownloadReportActionParams) => {
  return {
    label: i18n.t('time_tracking.menu.download_title'),
    description: i18n.t('time_tracking.menu.download_description'),
    onClick: onExportsModals(params, navigate, navigation),
  }
}
